import {ControllerBase} from "../../../controllerBase";

const PesquisarReservaController = ControllerBase.extend({
    name: "PesquisarReservaController",

    //dataBreadcrumb: new DataBreadcrumb({
    //    columns: [
    //        { title: 'Produto', prop: 'Codigo' },
    //        { title: 'Descrição', prop: 'Descricao' }
    //    ],
    //    getData: function () {

    //        return this.itemOrcamento.toJSON();
    //    },
    //}),

    ajax: function() {

        var pesquisa = {
            TamanhoPagina: this.pesquisa ? this.pesquisa.PageSize : 1000,
            NumeroPagina: this.pesquisa ? this.pesquisa.ActualPage : 1,
            Codigo: this.itemOrcamento.get("Codigo"),
            CodigoFilial: this.itemOrcamento.get("Filial")
        };

        return {
            url: "/Produto/_Reservas",
            type: "post",
            cache: false,
            contentType: "application/json",
            data: global.toJSONString({
                pesquisa: pesquisa
            })
        };
    },

    totalQuantidadeReservada: function(model) {
        return model.reduce(function(memo, value) { return memo + value.QuantidadeReservada }, 0);
    },

    totalQuantidadeDeposito: function(model) {
        return model[0].QuantidadeDeposito;
    },

    atualizarTotais: function() { 
        $("#td-reserva-pedido").html(global.formatNumber(this.totalQuantidadeReservada(this.model), 3));

        $("#td-reserva-deposito").html(global.formatNumber(this.totalQuantidadeDeposito(this.model), 3));
        var reservaTotal = this.totalQuantidadeReservada(this.model) + this.totalQuantidadeDeposito(this.model);
        //$("#td-reserva-total").html(global.formatNumber(this.totalQuantidadeReservada(this.model) + this.totalQuantidadeDeposito(this.model), 3));
        $("#td-reserva-total").html(global.formatNumber(reservaTotal, 3));
    },

    renderizado: function() {


        this.ReservaProdutoView = this.showView({
            region: {
                name: "reservaProdutoViewRegion",
                selector: "#pesquisar-reserva-produto-region"
            },
            view: {
                type: ReservaProdutoView,
                args: {
                    collection: new Reservas(this.model)
                }
            }
        });

        $("#descricao-produto-estoque-filial").html("<h3>" + this.produto + "</h3>");

        this.atualizarTotais();
    }
});

window.PesquisarReservaController = PesquisarReservaController

export {
    PesquisarReservaController
}